import React from 'react';
import BasePayrollForm from './BasePayrollForm';

const AddPayrollModal = ({
    showAddModal,
    setShowAddModal,
    formData,
    validationErrors,
    units,
    unitsLoading,
    unitsError,
    handleChange,
    handleAddSubmit,
    fetchUnits
}) => {
    if (!showAddModal) return null;

    return (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header" style={{
                        background: 'linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%)',
                        borderBottom: 'none'
                    }}>
                        <h5 className="modal-title text-white">
                            <i className="bi bi-plus-circle me-2"></i>
                            Add New Payroll Period
                        </h5>
                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={() => setShowAddModal(false)}
                        ></button>
                    </div>

                    <form onSubmit={handleAddSubmit}>
                        <BasePayrollForm
                            formData={formData}
                            validationErrors={validationErrors}
                            units={units}
                            unitsLoading={unitsLoading}
                            unitsError={unitsError}
                            handleChange={handleChange}
                            fetchUnits={fetchUnits}
                            mode="add"
                        />

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light border-secondary-subtle"
                                onClick={() => setShowAddModal(false)}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary text-white"
                                disabled={units.length === 0 || unitsLoading}
                            >
                                {unitsLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-plus-circle me-2"></i>
                                        Add Payroll Period
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddPayrollModal;